export const ItemTypes = {
  CARD: "card",
  SECTION: "section",
};
